import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import history from "./components/context/history";
import { Navbar } from "./components/navigation/Navbar";
import { Title } from "./components/title/Title";
import { Publication } from "./components/publication/Publication";
import { Dataset } from "./components/dataset/Dataset";
import { Downloads } from "./components/downloads/Downloads";
import { Team } from "./components/team/Team";

function App() {
  return (
    <div>
      <Router history={history}>
        <Navbar />
        <Title />
        <Dataset />
        <Publication />
        <Downloads />
        <Team />
      </Router>
    </div>
  );
}

export default App;
